import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, SortEvent } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { LocationService } from './location.service';
import Swal from 'sweetalert2';
import { Utilityservice } from '../../utility/utilityservice.service';
import { GlobalMessage } from '../../utility/modals';
import { LocationmodalComponent } from '../../directives/locationmodal/locationmodal.component';
import { ExceldownloadComponent } from '../../directives/exceldownload/exceldownload.component';
import { Table } from 'primeng/table';
import { PagehelpmodalService } from '../../directives/pagehelpmodal/pagehelpmodal.service';
import { BulkexceluploadComponent } from '../../directives/bulkexcelupload/bulkexcelupload.component';

@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.css']
})
export class LocationComponent implements OnInit {
  @ViewChild('dt') dt: Table;
  tableData: any[] = [];
  selectedItem: MenuItem | null = null;
  commonScrollHeight = '';
  searchText: string;
  ref: DynamicDialogRef | undefined;
  first2: number = 0;
  rows2: number = 10;
  totalRecords: number = 0;
  options = [];
  paginatorArray = []
  visible: boolean = false;
  excel_paragraph = '';
  templatedownloadtext = '';
  exceldownloadModal = false;
  downloadformate = false;
  position = 'top';
  cols = [];
  message: GlobalMessage = new GlobalMessage()
  _selectedColumns = [];
  currentNumberOfLocation: number;
  noOfLocation: number;
  isHub: String;
  isCity: String;
  isRegion: String;
  isContractType: String;
  contractTypeLabel: String;
  userRole: number;
  limitedAccess = "N";
  organisationList = [];
  parentdata: any;
  maxLocationReached: String = "No";
  searchTerm: string = ''; 

  constructor(public router: Router, public dialogService: DialogService,
    private locationservice: LocationService, public utilityservice: Utilityservice, public PagehelpmodalService: PagehelpmodalService) {
    this.excel_paragraph = this.message.downloadexcel_text;
    this.templatedownloadtext = this.message.excelformate_text
  }

  ngOnInit() {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight()
    this.getlocationList(this.sortfield, this.sortorder);
    this.getConfiguration();

    
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
  }
  searchcolumns = [];
  sortfield = 'locationname';
  sortorder = 1;
  selectedOrgId: string = '';
  dynamiccols() {
    this.cols = [
      { field: 'locationid', header: 'Location ID', type: 'text', sort: true, filter: true, width: '2px !important', isChecked: true, class: 'headerid' },
      { field: 'locationname', header: 'Location', type: 'text', sort: true, filter: true, width: '2px !important', isChecked: true, class: 'headerid' },
      { field: "countryname", header: "Country", type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "statename", header: "State", type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "createdby", header: "Created By", type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "createdon", header: "Created On", type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "activeflag", header: "Status", type: 'text', sort: false, filter: false, width: '20px', isChecked: true, class: 'otherheader' }
    ]
    if (this.isHub === "Y") {
      this.cols.splice(3, 0, {
        field: "hubname", header: "Hub", type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader'
      });
    }
    if (this.isRegion === "Y") {
      this.cols.splice(3, 0, {
        field: "regionname", header: "Region", type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader'
      });
    }
    if (this.isCity === "Y") {
      this.cols.splice(3, 0, {
        field: "cityname", header: "City", type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader'
      });
    }
    if (this.isContractType === "Y") {
      this.cols.splice(3, 0, {
        field: "locationtypename", header: this.contractTypeLabel, type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader'
      });
    }
    this.searchcolumns = this.cols.map(e => e.field);

    this._selectedColumns = this.cols;
  }
  currentPageIndex: number = 0

  // getlocationList(sortcoulmn, order) {
  //   const currentPageSize = this.rows2;
  //   const payload: any = {};

  //   if (this.userRole == 0 && this.selectedOrgId) {
  //     payload.orgid = this.selectedOrgId
  //   }
  //   this.locationservice.getall_location(payload).subscribe((data) => {
  //     this.tableData = data;
  //     // this.options=  this.utilityservice.getOptionDropdown(data.length);
  //     // this.paginatorArray=this.options.map(e=>e.value)
  //     // add logic for correct pagination
  //     this.options = this.utilityservice.getOptionDropdown(data.length) || [];
  //     this.paginatorArray = this.options.map((e: any) => +e.value);
  //     if (!this.paginatorArray.includes(currentPageSize)) {
  //       this.paginatorArray.push(currentPageSize);
  //       this.paginatorArray.sort((a, b) => a - b);
  //     }
  //     this.rows2 = currentPageSize;
  //     this.totalRecords = this.tableData.length;
  //     setTimeout(() => {
  //       if (this.dt) {
  //         this.dt.first = this.currentPageIndex;
  //         this.sortfield = sortcoulmn;
  //         this.sortorder = order
  //       }
  //     }, 0);
  //   });
  // }
  rowsize: number = 10;
  tablecount: number = 0;

  getlocationList(sortcoulmn, order) {
    //this.spinner.show();
    const currentPageSize = this.rowsize;
    const payload: any = {};

    if (this.userRole == 0 && this.selectedOrgId) {
      payload.orgid = this.selectedOrgId
    }
    this.locationservice.getall_location(payload).subscribe({
      next: (data: any) => {
        //this.spinner.hide();
        this.tableData = data;
        this.tableData = data.map((item: any) => ({ ...item, isSelect: false }));

        this.options = this.utilityservice.getOptionDropdown(data.length);
        this.paginatorArray = this.options.map((e) => e.value);

        if (!this.paginatorArray.includes(currentPageSize)) {
          this.paginatorArray.push(currentPageSize);
          this.paginatorArray.sort((a, b) => a - b);
        }

        this.rowsize = currentPageSize;
        this.totalRecords = this.tableData.length;
        this.tablecount = data.count ?? data.length;

        setTimeout(() => {
          if (this.dt) {
            this.dt.first = this.currentPageIndex;
          }
        }, 0);
      },
      error: (error) => {
        //this.spinner.hide();
        const timestamp = new Date().toLocaleString();
        Swal.fire({
          title: error.error?.error || "Error",
          text: `This error occurred at: ${timestamp}`,
          icon: "error",
        });
      },
    });
  }

  show(title, data) {
    let extraDetails = {};
    let details = {};
    extraDetails =
    {
      "locationTypeLabel": this.contractTypeLabel,
      "locationTypeEnabled": this.isContractType,
      "isHubEnabled": this.isHub,
      "isRegionEnabled": this.isRegion,
      "isCityEnabled": this.isCity,
      "tssprtlimitedaccess": this.limitedAccess,
      "userRole": this.userRole,
      "maxLocationsReached": this.maxLocationReached,
    }

    if (title === 'Modify Location') {
      this.locationservice.getLocationDataView_byId(data.locationid, data.orgid).subscribe(res => {
        details = res;
        this.ref = this.dialogService.open(LocationmodalComponent, {
          header: title,
          height: 'auto',
          width: '60vw',
          data: { title: title, datas: details, "extraDetails": extraDetails },
          contentStyle: {},
        });
        this.ref.onClose.subscribe((res) => {
          //if (res == "Save") {
          this.getlocationList(this.sortfield, this.sortorder);
          if(this.userRole != 0)
          {
            this.getConfiguration();
          }
          else{
            this.getConfigurationSuperAdmin(this.selectedOrgId);
          }
          //}
        });
      })
    } else {
      details = {}
      this.ref = this.dialogService.open(LocationmodalComponent, {
        header: title,
        width: '60vw',
        height: 'auto',
        data: { title: title, datas: details, "extraDetails": extraDetails },
        contentStyle: { overflow: '' },

      });
      this.ref.onClose.subscribe((res) => {
        //if (res == "Save") {
        this.getlocationList(this.sortfield, this.sortorder);
        if(this.userRole != 0)
        {
          this.getConfiguration();
        }
        else{
          this.getConfigurationSuperAdmin(this.selectedOrgId);
        }
        
        //}
      });
    }
  }

  showDialog() {
    let payload = {}
    const width = this.utilityservice.isMobile() ? '90vw' : 'auto';
    this.ref = this.dialogService.open(ExceldownloadComponent, {
      header: "Excel Download",
      width: width,
      height: '10rem',
      data: { excelname: "Location_Master_Data.xlsx", downloadapi: 'common/location/locationDataExcel', method: 'get', message: this.excel_paragraph, payload: payload },
      contentStyle: { overflow: 'hidden' },
      baseZIndex: 10000,
    });
  }

  excelUploadFormat() {
    this.locationservice.excelUploadFormat().subscribe((response: Blob) => {
      const blob = new Blob([response],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Location_Data_Format.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      this.downloadformate = false;
      Swal.fire('File downloaded successfully!', '', 'success');
    }, error => {
      Swal.fire('Something went wrong', '', 'error');
    });
  }

  handlePageChange(event: any) {
    this.rowsize = event.rows;
    this.currentPageIndex = event.first;
  }



  getConfiguration(): void {
    this.locationservice.getConfiguration().subscribe(
      (response) => {
        if (response && response.length > 0) {
          this.userRole = response[0]?.userRole;
          this.currentNumberOfLocation = response[0]?.currentNumberOfLocation;
          this.noOfLocation = response[0]?.noOfLocation;
          this.isHub = response[0]?.isHub;
          this.isCity = response[0]?.isCity;
          this.isContractType = response[0]?.isContractType;
          this.contractTypeLabel = response[0]?.contractTypeLabel;
          this.isRegion = response[0]?.isRegion;
          this.limitedAccess = response[0]?.tssprtlimitedaccess;
          this.dynamiccols();
          if (this.userRole == 0) {
            this.getOrganisation();
          }
          if ((this.currentNumberOfLocation >= this.noOfLocation) && this.userRole != 0 ) {
            this.maxLocationReached = "Yes";
          }
          else{
              this.maxLocationReached = "No";
          }
            
           
        }
      },
      (error) => {
        console.error('Error fetching configuration:', error);
      }
    );
  }


  getConfigurationSuperAdmin(selectedOrgId): void {
    this.locationservice.getConfigurationSuperAdmin(selectedOrgId).subscribe(
      (response) => {
        if (response && response.length > 0) {
          this.currentNumberOfLocation = response[0]?.currentNumberOfLocation;
          this.noOfLocation = response[0]?.noOfLocation; 
          if (this.currentNumberOfLocation >=   this.noOfLocation) {
            this.maxLocationReached = "Yes"; 
          }
          else{
            this.maxLocationReached = "No";
          }          
          
        }
      },
      (error) => {
        console.error('Error fetching configuration:', error);
      }
    );
  }

  getOrganisation() {
    this.locationservice.getOrganisations().subscribe(res => {
      this.organisationList = res;
      this.organisationList.unshift({ orgid: '', name: 'Select' });
    });
  }

  onOrgChange(orgId: string) {
    this.selectedOrgId = orgId;
    this.getlocationList(this.sortfield, this.sortorder);
    if(orgId != '')
    {
      this.getConfigurationSuperAdmin(orgId);
    }
    
  }

  openexceluploadmodal() {
    let payload = {}
    this.parentdata = {};
    this.parentdata = {
      title: 'Location Data Upload',
      apdownloadapi: 'common/location/uploadexcel',
      master: 'Location',
      sucessmessage: 'Location Data uploaded successfully!', 
      message:`You should have downloaded the Excel format for Location creation. You should have updated all the required information. The Excel file you choose will be uploaded and verified for accuracy. If there are no errors, the hierarchies will be created. Else, the errors will be displayed on the screen.`
   
    }
    this.ref = this.dialogService.open(BulkexceluploadComponent, {
      header: this.parentdata.title,
      width: '70%',
      height: '40',
      data: {
        uploadapi: this.parentdata.apdownloadapi,
        method: 'Post', message: this.parentdata.message, payload: payload, master: this.parentdata.master
      },
      contentStyle: { overflow: 'hidden' },
      position: 'center',
      style: { 'max-width': '100%', 'min-width': '60%' }
    }),
      this.ref.onClose.subscribe(res => {
        if (res == 'uploaded') {
          this.getlocationList(this.sortfield, this.sortorder);
        }
      })
  }


  onAddLocationClick() {
    if (
      this.currentNumberOfLocation < this.noOfLocation &&
      this.userRole == 1) { 
      this.locationservice.getConfiguration().subscribe(
        (response) => {
          if (response && response.length > 0) {
            this.currentNumberOfLocation = response[0]?.currentNumberOfLocation;
            this.noOfLocation = response[0]?.noOfLocation;

            if (this.noOfLocation <= this.currentNumberOfLocation) {
               Swal.fire({
                icon: 'warning',
                title: 'Maximum Allowed Locations Used',
                text: 'Please Contact Complinity Helpdesk'
              })
            } 
            else {
             this.show('Add Location', '');
            }
          }
        },
        (error) => {
          console.error('Error fetching configuration:', error);
        }
      );
    } else {
      Swal.fire({
        icon: 'warning',
        title: 'Maximum Allowed Locations Used',
        text: 'Please Contact Complinity Helpdesk'
      });
    }
  }

  onUploadModalClick() {
    if (
      this.noOfLocation > this.currentNumberOfLocation) {
      this.openexceluploadmodal();

    } else {
      Swal.fire({
        icon: 'warning',
        title: 'Maximum Allowed Locations Used',
        text: 'Please Contact Complinity Helpdesk'
      });
    }
  }

  excelDownload() {
    const payload = {
      orgId: this.selectedOrgId
    };
    this.locationservice.locationDataExcel(payload).subscribe((response: Blob) => {
      const blob = new Blob([response],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Location Master.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      this.exceldownloadModal = false;
      Swal.fire('File downloaded successfully! ', '', 'success');
    }, error => {
      Swal.fire('Something went wrong', '', 'error');
    });
  }

  cleanRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlight(input: string, searchstring: string | number): string {
    if (!searchstring) return input;
    const safeText = String(input ?? '');
    const safeSearch = this.cleanRegExp(String(searchstring));
    const re = new RegExp(safeSearch, 'gi');
    return safeText.replace(re, match => `<span class="highlightsearch">${match}</span>`);
  }

}



